<template>
  <div class="customer-detail">
    <el-row :gutter="10" style="margin: 16px 0">
      <el-col>
        <el-button
          v-for="item in tabs"
          :key="item.value"
          :type="activeTab === item.value ? 'primary' : ''"
          @click="activeTab = item.value"
        >
          {{ item.name }}
        </el-button>
      </el-col>
    </el-row>
    <keep-alive>
      <component :is="`tab-${activeTab}`"></component>
    </keep-alive>
  </div>
</template>

<script>
import info from '@/views/customer/components/info'
import history from '@/views/customer/components/history'
import address from '@/views/customer/components/address'
export default {
  components: {
    'tab-info': info,
    'tab-history': history,
    'tab-address': address,
  },
  activated() {
    this.activeTab = 'info'
  },
  data() {
    return {
      activeTab: 'info',
      tabs: [
        { name: this.$t('customer::customer-list::base_info'), value: 'info' },
        { name: this.$t('customer::customer-list::buy_history'), value: 'history' },
        { name: this.$t('customer::customer-list::shipping_address'), value: 'address' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.nav {
  font-size: 18px;
  font-weight: bold;
}
.tab-item {
  display: inline-block;
  width: 150px;
  height: 70px;
  line-height: 70px;
  text-align: center;
  color: #7f7f7f;
  background: #d7d7d7;
  margin-right: 20px;
  box-sizing: border-box;
  font-size: 16px;
  cursor: pointer;
}
.active {
  color: #010517;
  background: #fff;
  border-bottom: 2px solid #027db4;
}
/deep/.el-divider {
  background-color: #010517;
}
</style>
